

import { PlatformModule } from '@angular/cdk/platform';
import { NgModule } from '@angular/core';

import { MwcTransitionPatchDirective } from './transition-patch.directive';

@NgModule({
  imports: [PlatformModule],
  exports: [MwcTransitionPatchDirective],
  declarations: [MwcTransitionPatchDirective]
})
export class MwcTransitionPatchModule {}
